import { IngestDataType } from "@nova/schemas"
import { fileManagementApi } from "features/data-management/files/fileManagementApi"

export async function uploadWorkspaceLogoToS3(organizationId: string, logoId: string, blob: Blob) {
    const key = `public/org/${organizationId}/assets/${logoId}`
    const { ingestResponse } = await fileManagementApi.putFile(blob, {
        filename: logoId,
        tags: { orgId: organizationId, dataType: IngestDataType.Copy, nextPath: key },
    })
    if (ingestResponse.status !== "success") {
        throw new Error(`Failed to upload logo (ingest status: ${ingestResponse.status})`)
    }
    return key
}

export async function uploadPDFLogoToS3(organizationId: string, logoId: string, blobUrl: string) {
    const blobResponse = await fetch(blobUrl)
    if (!blobResponse.ok) {
        throw new Error("PDF logo -- failed to fetch blob")
    }
    const blob = await blobResponse.blob()
    return await uploadWorkspaceLogoToS3(organizationId, logoId, blob)
}
